import { Injectable } from '@angular/core';
import { Utilisateur } from '../classes/utilisateur';
import { Droit } from '../classes/droit';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TokenService } from './token.service';
import { EncryptionService } from './encryption.service';
@Injectable({
  providedIn: 'root'
})
export class UtilisateursService {
  private id_pers;
  private options = {};
  constructor(private http: HttpClient, private tokenService : TokenService, private encryptService : EncryptionService) { }
  // Fonction pour lancer Verification token activite
  loadToken() {
    this.id_pers = localStorage.getItem('id');
    const token = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user"))).token;
    const id_pers = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user"))).id_pers;
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'head_hex': '' + token,
      'hid_hex': '' + id_pers,
    });
    this.options = {
      headers: httpHeaders,
    };
  }
  getUsers() {
    /*let users : Utilisateur[] = [];
    let userList = [
      {
        "id" : 1245,
        "nom" : "Doe",
        "prenom" : "John",
        "droit" : "Administration"
      },
      {
        "id" : 1246,
        "nom" : "Doe",
        "prenom" : "Janne",
        "droit" : "Supervision"
      },
      {
        "id" : 1247,
        "nom" : "Doe",
        "prenom" : "Baby",
        "droit" : "CQ"
      },
      {
        "id" : 1248,
        "nom" : "Doe",
        "prenom" : "Johnny",
        "droit" : "Modérateur"
      },
      {
        "id" : 1249,
        "nom" : "Doe",
        "prenom" : "Jannie",
        "droit" : "Client"
      },
    ];

    userList.forEach(item => {
      let instance : Utilisateur = {
        id: item.id,
        nom: item.nom,
        prenom: item.prenom,
        droit: item.droit
      }

      users.push(instance);
    });

    return users;*/
  }

  getDroits() {
    let droits: any[] = [];
    let droitList = [
      {
        "id" : 1,
        "designation" : "Administrateur",
      },
      {
        "id" : 2,
        "designation" : "Supervision",
      },
      {
        "id" : 3,
        "designation" : "CQ",
      },
      {
        "id" : 4,
        "designation" : "Modérateur",
      },
      {
        "id" : 5,
        "designation" : "Client",
      },
    ];

    droitList.forEach(item => {
      let droit: Droit = {
        id: item.id,
        designation: item.designation
      }

      droits.push(droit);
    });

    return droits;
  }

  // Fonction Recuperation tous list personne
  getAllListUtilisateur(beta) {
    const id_Temp = 0;
    this.loadToken();
    return this.http.post ('/api/utilisateur/getall', {
      id_Temp,
    }, this.options);
  }
  // Fonction Recuperation tous list droit
  getAllListDroit() {
    const id_Droit = 0;
    this.loadToken();
    return this.http.post ('/api/droit/getalldroit', {}
    , this.options);
  }
  // Fonction insertion nouveau utilisateur
  InsererUtilisateur(obj) {
    this.loadToken();
    return this.http.post ('/api/utilisateur/createuser', {
      obj
    }, this.options);
  }
  // Fonction insertion nouveau utilisateur CLient
  InsererUtilisateurClient(obj) {
    this.loadToken();
    return this.http.post ('/api/utilisateur/createuserclient', {
      obj
    }, this.options);
  }
  // Fonction modification utilisateur
  ModifierUtilisateur(obj) {
    return this.http.post ('/api/utilisateur/updateutilisateur', {
      obj
    }, this.options);
  }
  // Fonction modification mot de passe utilisateur
  ModifierMdpUtilisateur(obj) {
    return this.http.post ('/api/utilisateur/updatepass', {
      obj
    });
  }


  getListeOp() {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/utilisateur/liste-op";
    return this.http.get(request, {headers : httpHeaders});
  }

  getListeOpDetails() {
    let httpHeaders = this.tokenService.loadToken();
    let request = '/api/utilisateur/op-details'
    return this.http.get(request, {headers : httpHeaders});
  }


  reinitPass(matricule:number) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/utilisateur/reinit-pass?matricule=" + matricule;
    return this.http.post(request,  {} ,{headers: httpHeaders});
  }


  updatePassword(matricule:number,actual:string,newPass:string) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/utilisateur/update-pass";
    let param = {
      matricule:matricule,
      actual:actual,
      new:newPass
    };
    return this.http.post(request,  param ,{headers: httpHeaders});
  }


  setSupervision(matricule:number, superviser : boolean) {
    let request = '/api/utilisateur/set-supervision';
    let httpHeaders = this.tokenService.loadToken();
    let param = {
      matricule : matricule,
      superviser : superviser
    };
    return this.http.post(request,  param ,{headers: httpHeaders});
  }

} 
